import { QuoteAdvisories } from './quote-advisories';

export class Quote {
  orderLines: OrderLineDto[];
  shipViaOptions: ShipViaOptionDto[];
  id: string;
  shipByDate: Date;
  shipViaCode: string;
  totalTaxAmount: number;
  totalMerchandiseAmountToShip: number;
  totalShippingAndHandlingAmount: number;
  consignmentTotal: number;
  totalAmount: number;
  isValid: boolean;
  hasUserAcceptedTermsAndConditions: boolean;
  advisories: QuoteAdvisories[];
  orderOptions: OrderOptionsDto;
  deliveryOptions: DeliveryOptionsDto;
  worksheetId: string;
  statusMessages: StatusMessageDto[];
  hasStatusMessages: boolean;
  isSkuCountValid: boolean;
  isShippingAndHandlingValid: boolean;
  isTermsValid: boolean;
  isMarketValid: boolean;
  areAllSkusAreValid: boolean;
  areAllBackordersValid: boolean;
  isRealQuote: boolean;
  inCheckout: boolean;
  userQuoteCacheIfAvailable: boolean;
  backorderedOnly: boolean;
  inStockOnly: boolean;
  isCheckoutBlocked: boolean;
  generatePORRequired:boolean;
  isOrderHeldIncomplete: boolean;
  constructor(data: any = {}) {
    this.orderOptions = data.orderOptions || new OrderOptionsDto();
  }
}

export class StatusMessageDto {
  code: string;
  message: string;
}

export class ShipViaOptionDto {
  code: string;
  deliveryDayPromise: number;
  deliveredByDate: string;
  shippingAndHandling: {
    isValidOption: boolean;
    totalChargeAmount: number;
  };
}

export class OrderLineDto {
  price: number;
  quantity: number;
  quantityAvailable: number;
  advisories: string[];
  bomLineId: string;
  backorderAvailability: {estimatedStockingDate: string }[];
  sku: string;
  isTesscoTuned: boolean;
  isConsignmentItem: boolean;
}

export class OrderOptionsDto {
  requestedShipDate: string;
  isBackorderPartial: boolean;
  isBackorderSplit: boolean;
  isPartial: boolean;
  isSplit: boolean;
  processing: ProcessingOptionsDto;
  orderProcessing: OrderProcessingOptionsDto;

  constructor(data: any = {}) {
    this.requestedShipDate = data.requestedShipDate || new Date().toISOString();
    this.isBackorderPartial = data.isBackorderPartial || true;
    this.isBackorderSplit = data.isBackorderSplit || true;
    this.isPartial = data.isPartial || true;
    this.isSplit = data.isSplit || true;
    this.orderProcessing = data.orderProcessing || new OrderProcessingOptionsDto();
    this.processing = data.processing || new ProcessingOptionsDto();
  }
}

export class DeliveryOptionsDto {
  backorderShipVia: string;
  deliverByDate: string;
  fobTerms: 'None' | 'Origin' | 'Destination';
  freightPolicy: 'None' | 'Collect' | 'Prepay';
  isFreightOnBackordersRequired: boolean;
  isFreightOnOriginalOrderRequired: boolean;
  isHandCarry: boolean;
  isInsideDeliveryRequired: boolean;
  isLiftGateRequired: boolean;
  isSaturdayDelivery: boolean;
  preferredCarrier: boolean;
  shipOnDate: string;
  shippingAndHandlingFixedCharge: number;
  shippingAndHandlingPolicy: 'None' | 'Calculate' | 'Fixed' | 'Update';

  constructor(data: any = {}) {
    this.backorderShipVia = data.backorderShipVia || '3';
    this.deliverByDate = data.deliverByDate || new Date().toISOString();
    this.fobTerms = data.fobTerms || 'None';
    this.freightPolicy = data.freightPolicy || 'None';
    this.isFreightOnBackordersRequired = data.isFreightOnBackordersRequired || false;
    this.isFreightOnOriginalOrderRequired = data.isFreightOnOriginalOrderRequired || false;
    this.isHandCarry = data.isHandCarry || false;
    this.isInsideDeliveryRequired = data.isInsideDeliveryRequired || false;
    this.isLiftGateRequired = data.isLiftGateRequired || false;
    this.isSaturdayDelivery = data.isSaturdayDelivery || false;
    this.preferredCarrier = data.preferredCarrier || false;
    this.shipOnDate = data.shipOnDate || new Date().toISOString();
    this.shippingAndHandlingFixedCharge = data.shippingAndHandlingFixedCharge || '0';
    this.shippingAndHandlingPolicy = data.shippingAndHandlingPolicy || 'None';
  }
}

export class OrderProcessingOptionsDto {
  // PackingListLocation and InvoiceLocation must be number:
  // None(0), Inside(1), Outside(2)
  isPackingListPriced: boolean;
  packingListLocation: number;
  invoiceLocation: number;
  packingListCopiesCount: number;
  specialHandling: string;

  constructor(data: any = {}) {
    this.specialHandling = data.specialHandling || '';
    this.packingListLocation = data.packingListLocation || 2;
    this.invoiceLocation = data.invoiceLocation || 2;
    this.packingListCopiesCount = data.packingListCopiesCount || 2;
    this.isPackingListPriced = data.isPackingListPriced || false;
  }
}

export class ProcessingOptionsDto {
  isPackingListPriced: boolean;
  packingListLocation: 'None' | 'Inside' | 'Outside';
  invoiceLocation: 'None' | 'Inside' | 'Outside';
  packingListCopiesCount: number;
  specialHandling: string;
  purchasePlan: string;
}





// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/quote.ts